export default "__VITE_ASSET__B3BfKT7T__"